import * as advanceDiagnosticScreenTypes from '../../consts/yap/advanceDiagnosticScreenTypes';
import * as advanceDiagnosticScreenSteps from './advanceDiagnosticScreenSteps';

export default [
    {
        //default config if no such type found
        partialScreen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ELIGIBILITY_SCREEN,
    },
    {
        chargerFlow: advanceDiagnosticScreenSteps.MARKET_FLOW,
        holderFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_MARKET_FLOW,
        partialScreen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ELIGIBILITY_SCREEN,
    },
    {
        chargerFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_MARKET_FLOW,
        holderFlow: advanceDiagnosticScreenSteps.MARKET_FLOW,
        partialScreen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ELIGIBILITY_SCREEN,
    },
    {
        chargerFlow: advanceDiagnosticScreenSteps.MARKET_FLOW,
        holderFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_RESET_FLOW,
        partialScreen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ELIGIBILITY_SCREEN,
    },
    {
        chargerFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_RESET_FLOW,
        holderFlow: advanceDiagnosticScreenSteps.MARKET_FLOW,
        partialScreen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ELIGIBILITY_SCREEN,
    },
    {
        chargerFlow: advanceDiagnosticScreenSteps.MARKET_FLOW,
        holderFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_ADAPTOR_MSG_FLOW,
        partialScreen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ELIGIBILITY_SCREEN,
    },
    {
        chargerFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_ADAPTOR_MSG_FLOW,
        holderFlow: advanceDiagnosticScreenSteps.MARKET_FLOW,
        partialScreen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ELIGIBILITY_SCREEN,
    },
    {
        chargerFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_RESET_FLOW,
        holderFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_ADAPTOR_MSG_FLOW,
        partialScreen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ADAPTOR_SCREEN,
    },
    {
        chargerFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_ADAPTOR_MSG_FLOW,
        holderFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_RESET_FLOW,
        partialScreen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ADAPTOR_SCREEN,
    },
    {
        chargerFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_MARKET_FLOW,
        holderFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_RESET_FLOW,
        partialScreen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ELIGIBILITY_SCREEN,
    },
    {
        chargerFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_RESET_FLOW,
        holderFlow: advanceDiagnosticScreenSteps.FWU_CHECK_AND_MARKET_FLOW,
        partialScreen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ELIGIBILITY_SCREEN,
    },
];
